import './Title.css';

function TitleComp({text}) {
    return (
        <div className="Title">
            {text}
        </div>
    );
} 

export default TitleComp;